export default __webpack_public_path__ + "static/media/undraw_multitasking_hqg3.fa33bd3a.svg";